import { useEffect, useState } from 'react'
import Message from '@talkdesk/cobalt-react-message'
import Button from '@talkdesk/cobalt-react-button'
import {
  GENERIC_SERVER_ERROR,
  PASSWORD_CHANGE_TITLE,
  PASSWORD_SETTINGS_LOCAL_LOGIN_DISABLED,
  PASSWORD_SETTINGS_TITLE,
} from '../../constants/ui.labels'
import SettingItem from '../Settings/SettingItem'
import mapError from '../../utils/mapError/userManagement'
import ToastError from '../ToastError'
import Flex from '@talkdesk/cobalt-react-flex'
import { Text } from '@talkdesk/cobalt-react-typography'

const PasswordSettings = ({
  goToChangePasswordPage,
  isLocalLoginEnabled,
  isPasswordSetupInProgress,
  errorCode,
}) => {
  const [toastError, setToastError] = useState(null)

  const dismissToastError = () => setToastError(null)

  /* eslint-disable react-hooks/set-state-in-effect, @eslint-react/set-state-in-effect */
  useEffect(() => {
    if (errorCode) {
      setToastError(
        <ToastError
          title={mapError(errorCode, GENERIC_SERVER_ERROR)}
          onDismiss={dismissToastError}
        />,
      )
    }
  }, [errorCode])
  /* eslint-enable react-hooks/set-state-in-effect, @eslint-react/set-state-in-effect */

  const state = isPasswordSetupInProgress ? Button.LOADING_STATE : null
  const actionButton = (
    <Button
      htmlType='button'
      size='small'
      variation='outline'
      state={state}
      onClick={goToChangePasswordPage}
      disabled={!isLocalLoginEnabled || isPasswordSetupInProgress}
    >
      {PASSWORD_CHANGE_TITLE}
    </Button>
  )

  return (
    <>
      <SettingItem title={PASSWORD_SETTINGS_TITLE} actionButton={actionButton}>
        {!isLocalLoginEnabled && (
          <Message type='warning'>
            <Flex padding='3' gap='3' alignY='center'>
              <Text>{PASSWORD_SETTINGS_LOCAL_LOGIN_DISABLED}</Text>
            </Flex>
          </Message>
        )}
      </SettingItem>
      {toastError}
    </>
  )
}

export default PasswordSettings
